// exposed empty class to identify deferred data
export default class Deferred {}
